"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowTotalsPlugin = void 0;
const big_js_1 = __importDefault(require("big.js"));
const _ = __importStar(require("lodash"));
const slickgrid_1 = require("slickgrid");
const helpers_1 = require("../helpers");
class RowTotalsPlugin {
    pluginName = 'RowTotals';
    _eventHandler = new slickgrid_1.SlickEventHandler();
    _grid;
    init(grid) {
        this._grid = grid;
        this.updateAllTotals();
        this._eventHandler.subscribe(grid.onCellChange, this.onCellChanged.bind(this));
        this._eventHandler.subscribe(grid.onSelectedRowsChanged, this.onSelectedRowsChanged.bind(this));
        this._eventHandler.subscribe(grid.onColumnsReordered, this.updateAllTotals.bind(this));
        this._eventHandler.subscribe(grid.onColumnsResized, this.updateAllTotals.bind(this));
        const dv = this._grid.getData();
        this._eventHandler.subscribe(dv.onRowsOrCountChanged, this.onRowsOrCountChanged.bind(this));
    }
    destroy() {
        this._eventHandler.unsubscribeAll();
    }
    onCellChanged(e, args) {
        this.updateTotal(args.column);
    }
    onSelectedRowsChanged(e, args) {
        this.updateAllTotals();
    }
    onColumnsReordered(e, args) {
        this.updateAllTotals();
    }
    onRowsOrCountChanged(e, args) {
        this.updateAllTotals();
    }
    updateAllTotals() {
        if (this._grid.getFooterRowColumn(0)) {
            this._grid.getColumns().forEach(col => this.updateTotal(col));
        }
    }
    updateTotal(column) {
        let totals = null;
        if (column.type === 'number' && !column.noFooterTotals) {
            totals = this.calculateTotals(column);
        }
        this.displayTotals(column, totals);
    }
    calculateTotals(column) {
        const hasSelection = this._grid.getSelectedRows().length > 0;
        let total = new big_js_1.default(0);
        let selectionTotal = new big_js_1.default(0);
        const dv = this._grid.getData();
        const field = _.toString(column.field);
        _.each(_.range(dv.getLength()), i => {
            const d = dv.getItem(i);
            const value = d[field] || 0;
            if ((0, helpers_1.isRowSelected)(d)) {
                selectionTotal = selectionTotal.plus(value);
            }
            total = total.plus(value);
        });
        return {
            total: Number(total.toString()),
            selectionTotal: hasSelection ? Number(selectionTotal.toString()) : null
        };
    }
    displayTotals(column, value) {
        const grid = this._grid;
        let content = '';
        let selected = false;
        if (value && _.isNumber(value.total)) {
            content = column.formatter
                ? column.formatter(-1, -1, value.total, column, {}, grid).toString()
                : value.total.toString();
        }
        if (value && _.isNumber(value.selectionTotal)) {
            selected = true;
            content = column.formatter
                ? column
                    .formatter(-1, -1, value.selectionTotal, column, {}, grid)
                    .toString()
                : value.selectionTotal.toString();
        }
        const columnElement = grid.getFooterRowColumn(column.id);
        if (!columnElement) {
            console.warn(`Cannot display footer total '${content}'. Could not get footer row column. Column id: ${column.id}`);
            return;
        }
        if (selected) {
            columnElement.classList.add("selected");
        }
        else {
            columnElement.classList.remove("selected");
        }
        (0, helpers_1.applyFormatterResult)(columnElement, content);
    }
}
exports.RowTotalsPlugin = RowTotalsPlugin;
//# sourceMappingURL=RowTotalsPlugin.js.map